export class configuration {

	// public urlname 			: string  = 'local';
	// public org				: string  = 'local';
	// public mc				: string  = 'http://127.0.0.1:8003/';
	public urlname 			: string  = 'esscalo';
	public org				: string  = 'grupoesscalo';
	public mc				: string  = '//api.esscaloseguros.solutions/';
	public multianual 		: boolean = false;
	public seleccion_valor 	: boolean = true;
	public policy_emit      : boolean = false;	

};





// WEBPACK FOOTER //
// ./src/config/config.ts